import React, { Component } from 'react';
import { solidIcons, regularIcons, brandsIcons } from './faIconList';
import { FormattedMessage, injectIntl } from 'react-intl';

const styleTabs = [
    { key: 'solid',   label: 'Solid',   prefix: 'fa-solid',   icons: solidIcons },
    { key: 'regular', label: 'Regular', prefix: 'fa-regular', icons: regularIcons },
    { key: 'brands',  label: 'Brands',  prefix: 'fa-brands',  icons: brandsIcons },
];

class IconPicker extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            search: '',
            activeTab: props.iconStyle || 'solid',
            hoveredIcon: null,
        };
        this.wrapperRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }

    handleOutsideClick = (e) => {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(e.target)) {
            this.setState({ open: false });
        }
    }

    toggle = () => this.setState(s => ({ open: !s.open, search: '' }));

    selectIcon = (iconName) => {
        const { activeTab } = this.state;
        this.props.onSelect({ iconName, iconStyle: activeTab });
        this.setState({ open: false, search: '' });
    };

    clearIcon = (e) => {
        e.stopPropagation();
        this.props.onSelect({ iconName: '', iconStyle: '' });
        this.setState({ open: false });
    };

    render() {
        const { iconName, iconStyle, intl } = this.props;
        const { open, search, activeTab, hoveredIcon } = this.state;
        const currentTab = styleTabs.find(t => t.key === activeTab) || styleTabs[0];
        const filtered = [...new Set(currentTab.icons)].filter(n =>
            !search || n.toLowerCase().includes(search.toLowerCase())
        );
        const selectedPrefix = (styleTabs.find(t => t.key === (iconStyle || 'solid')) || styleTabs[0]).prefix;

        return (
            <div ref={this.wrapperRef} style={{ position: 'relative' }}>
                <div
                    onClick={this.toggle}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        border: '1px solid #ced4da',
                        borderRadius: 4,
                        backgroundColor: '#fff',
                        cursor: 'pointer',
                        height: 38,
                        overflow: 'hidden',
                    }}
                >
                    <div style={{
                        width: 38,
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRight: '1px solid #ced4da',
                        backgroundColor: iconName ? '#f8f9fa' : 'transparent',
                        flexShrink: 0,
                        fontSize: 16,
                        color: '#495057',
                    }}>
                        {iconName
                            ? <i className={`${selectedPrefix} fa-${iconName}`} />
                            : <i className="fa-regular fa-face-smile" style={{ color: '#ced4da' }} />
                        }
                    </div>

                    <span style={{
                        flex: 1,
                        padding: '0 10px',
                        fontSize: 14,
                        color: iconName ? '#495057' : '#adb5bd',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}>
                        {iconName || intl.formatMessage({ id: 'VoucherTags.ChooseIcon' })}
                    </span>

                    <div style={{
                        width: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        color: '#6c757d',
                    }}>
                        <i className={`fa-solid fa-chevron-${open ? 'up' : 'down'}`} style={{ fontSize: 11 }} />
                    </div>
                </div>

                {open && (
                    <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        zIndex: 9999,
                        background: '#fff',
                        border: '1px solid #ced4da',
                        borderRadius: 4,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        width: 400,
                        padding: 10,
                    }}>
                        <div style={{ display: 'flex', borderBottom: '1px solid #dee2e6', marginBottom: 8 }}>
                            {styleTabs.map(t => (
                                <div
                                    key={t.key}
                                    onClick={() => this.setState({ activeTab: t.key, search: '' })}
                                    style={{
                                        padding: '4px 12px',
                                        cursor: 'pointer',
                                        fontSize: 12,
                                        fontWeight: activeTab === t.key ? 600 : 400,
                                        borderBottom: activeTab === t.key ? '2px solid #64dd17' : '2px solid transparent',
                                        color: activeTab === t.key ? '#64dd17' : '#495057',
                                        marginBottom: -1,
                                    }}
                                >
                                    {t.label}
                                </div>
                            ))}
                        </div>

                        <input
                            className="form-control form-control-sm mb-2"
                            placeholder={intl.formatMessage({ id: 'VoucherTags.SearchIcon' })}
                            value={search}
                            onChange={e => this.setState({ search: e.target.value })}
                            autoFocus
                        />

                        <div key={activeTab} style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(8, 1fr)',
                            gap: 4,
                            maxHeight: 240,
                            overflowY: 'auto',
                        }}>
                            {filtered.length === 0 ? (
                                <div style={{ gridColumn: '1 / -1', textAlign: 'center', color: '#888', padding: 8, fontSize: 12 }}>
                                    <FormattedMessage id="VoucherTags.NoIconsFound" />
                                </div>
                            ) : filtered.map(name => {
                                const isSelected = name === iconName && (iconStyle || 'solid') === activeTab;
                                const isHovered = hoveredIcon === name && !isSelected;
                                return (
                                    <div
                                        key={`${activeTab}-${name}`}
                                        title={name}
                                        onClick={() => this.selectIcon(name)}
                                        onMouseEnter={() => this.setState({ hoveredIcon: name })}
                                        onMouseLeave={() => this.setState({ hoveredIcon: null })}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: 34,
                                            borderRadius: 4,
                                            cursor: 'pointer',
                                            fontSize: 15,
                                            background: isSelected ? '#1d92fc' : isHovered ? '#f0f0f0' : 'transparent',
                                            color: isSelected ? '#fff' : '#333',
                                        }}
                                    >
                                        <i className={`${currentTab.prefix} fa-${name}`} />
                                    </div>
                                );
                            })}
                        </div>

                        {iconName && (
                            <div style={{ textAlign: 'right', marginTop: 8 }}>
                                <span
                                    onClick={this.clearIcon}
                                    style={{ fontSize: 11, color: '#dc3545', cursor: 'pointer' }}
                                >
                                    <i className="fa-solid fa-times" style={{ marginRight: 4 }} />
                                    <FormattedMessage id="VoucherTags.ClearIcon" />
                                </span>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default injectIntl(IconPicker);
